package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Insert
import androidx.room3.OnConflictStrategy
import androidx.room3.Query
import androidx.room3.RawQuery
import androidx.room3.RoomRawQuery
import com.xtream.data_kmp.WatchedIntermediateVodStream
import com.xtream.data_kmp.dto.TrendingMovie
import com.xtream.data_kmp.dto.VodStream
import kotlinx.coroutines.flow.Flow


enum class MovieSortBy {
    DEFAULT,
    NAME_ASC,
    NAME_DESC,
    LAST_ADDED,
    RATING,

}
@Dao
abstract class VodStreamsDao:BaseRoomStreamsInterface<VodStream> {

    @Query("SELECT * FROM vodTable WHERE streamId = :id LIMIT 1")
   abstract suspend fun getStreamById(id: Int?): VodStream?



    @Query("SELECT * FROM vodTable ORDER BY added DESC LIMIT 10")
    abstract override suspend fun recentlyAdded(): List<VodStream>
   // @Query("SELECT * FROM vodTable ORDER BY ratingFiveBased DESC LIMIT 10")
    @Query("""
        SELECT * FROM vodTable
        ORDER BY added DESC
        LIMIT :limit
        """)
    abstract override fun recentlyAddedFlow(limit: Int): Flow<List<VodStream>>

    @Query("SELECT COUNT(*) FROM vodTable ORDER BY added DESC  LIMIT 10")
    abstract override fun getRecentlyAddedSize(): Flow<Long>

    @Query("SELECT * FROM vodTable ORDER BY added DESC")
    abstract override fun allAsFlow(): Flow<List<VodStream>>


    @Query("SELECT * FROM vodTable "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +" ORDER BY added DESC"
            +" LIMIT :limit OFFSET :offset"

        /*+"ORDER BY sortOrder"*/)
    abstract suspend fun all(categoryId:Int?, nameQuery:String?, limit: Int?, offset: Int?): List<VodStream>



    @Query("SELECT * FROM vodTable "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +" ORDER BY added DESC"
            +" LIMIT :limit OFFSET :offset"

        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsFlow(categoryId:Int?, nameQuery:String?, limit: Int?, offset: Int?): Flow<List<VodStream>>

    @Query("""SELECT * FROM vodTable 
            WHERE (:categoryId IS NULL OR categoryId = :categoryId)
             AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') 
             ORDER BY added DESC"""
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsFlow(categoryId:Int?, nameQuery:String?): Flow<List<VodStream>>


    @Query("""SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num' 
             FROM vodTable 
            INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId 
            ORDER BY vodFavoritesTable.sortOrder ASC 
             LIMIT :limit""")
    abstract override fun getFavoriteStreamsFlow( limit: Int?):  Flow<List<VodStream>>


    @Query("SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num' " +
            " FROM vodTable " +
            "INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId " +
            "ORDER BY vodFavoritesTable.sortOrder ASC" +
            " LIMIT :limit")
    abstract suspend fun getFavoriteStreams( limit: Int?):  List<VodStream>

    @Query("SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num' " +
            " FROM vodTable " +
            "INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId " +
            "ORDER BY vodFavoritesTable.sortOrder ASC")
    abstract  override suspend fun getFavoriteStreams():  List<VodStream>

    @Query("SELECT * FROM vodTable "
            +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +" ORDER BY added DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsPagingSource(categoryId:Int?, nameQuery:String?): PagingSource<Int, VodStream>

    @Query("SELECT * FROM vodTable "
            +"WHERE (:categoryIds IS NULL OR categoryId IN (:categoryIds))"
            +" AND (:nameQuery IS NULL OR name LIKE '%' || :nameQuery || '%') "
            +" ORDER BY added DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsPagingSource(categoryIds: List<Int>?, nameQuery: String?): PagingSource<Int, VodStream>
    @RawQuery(observedEntities = [VodStream::class])
    abstract fun allAsPagingSourceRaw(query: RoomRawQuery): PagingSource<Int, VodStream>
    fun allAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
        sortBy: MovieSortBy,
        yearRange: IntRange? = null,
    ): PagingSource<Int, VodStream> {
        val orderClause = when (sortBy) {
            MovieSortBy.DEFAULT    -> "CAST(added AS INTEGER) DESC"
            MovieSortBy.NAME_ASC   -> "name ASC"
            MovieSortBy.NAME_DESC  -> "name DESC"
            MovieSortBy.LAST_ADDED -> "CAST(added AS INTEGER) DESC"
            MovieSortBy.RATING     -> "CAST(rating AS REAL) DESC"
        }

        val args = mutableListOf<Any>()
        val whereClause = buildString {
            append("WHERE 1=1 ")
            if (!categoryIds.isNullOrEmpty()) {
                val placeholders = categoryIds.joinToString(",") { "?" }
                append("AND categoryId IN ($placeholders) ")
                args.addAll(categoryIds)
            }
            if (!nameQuery.isNullOrEmpty()) {
                append("AND name LIKE ? ")
                args.add("%$nameQuery%")
            }
            if (yearRange != null) {
                append("AND CAST(added AS INTEGER) BETWEEN ? AND ? ")
                args.add(yearRange.first)
                args.add(yearRange.last)
            }
        }

        val sql = "SELECT * FROM vodTable $whereClause ORDER BY $orderClause"
        println("VodStreamsDao SQL: $sql | args: $args")  // check Logcat

        return allAsPagingSourceRaw(RoomRawQuery(sql) { stmt ->
            args.forEachIndexed { index, arg ->
                when (arg) {
                    is Int    -> stmt.bindLong(index + 1, arg.toLong())
                    is String -> stmt.bindText(index + 1, arg)
                }
            }
        })
    }
    @Query("""
        SELECT * FROM vodTable
         ORDER BY added DESC
        LIMIT :limit
    """)
    abstract override fun getRecentlyAdded(limit: Int): PagingSource<Int, VodStream>

    @Query("""
        SELECT * FROM vodTable
         ORDER BY added DESC
        LIMIT :limit
    """)
    abstract override fun getRecentlyAddedFlow(limit: Int): Flow<List<VodStream>>


@Query("""
        SELECT * FROM vodTable
         ORDER BY added DESC
        LIMIT :limit
    """)
    abstract suspend fun getRecentlyAddedList(limit: Int): List<VodStream>




    @Query("""
        SELECT * FROM vodTable
        WHERE (:categoryId IS NULL OR categoryId = :categoryId)
        ORDER BY RANDOM() 
        LIMIT :limit
    """)
    abstract override fun getRecommendations(categoryId:Int?,limit: Int): PagingSource<Int, VodStream>
    @Query("""
    SELECT * FROM vodTable
    WHERE (:categoryId IS NULL OR categoryId = :categoryId)
    AND (:excludeIds IS NULL OR streamId NOT IN (:excludeIds))
    ORDER BY RANDOM()
    LIMIT :limit
""")
    abstract fun getRecommendationsList(
        categoryId: Int?,
        limit: Int,
        excludeIds: List<Int?>? = null
    ): Flow<List<VodStream>>
    @Query("SELECT * FROM vodTable "
            +" ORDER BY added DESC"
        /*+"ORDER BY sortOrder"*/)
    abstract override fun allAsPagingSource(): PagingSource<Int, VodStream>



    @Query("SELECT vodTable.*, vodFavoritesTable.sortOrder AS  'num' " +
            " FROM vodTable " +
            "INNER JOIN vodFavoritesTable ON vodTable.streamId = vodFavoritesTable.streamId " +
            "ORDER BY vodFavoritesTable.sortOrder ASC")
    abstract override fun getPagedFavoriteStreams(): PagingSource<Int, VodStream>

    @Query("SELECT *  FROM vodTable " +
            "INNER JOIN watchedVodStreamsTable ON vodTable.streamId = watchedVodStreamsTable.streamId "+
        "    ORDER BY watchedVodStreamsTable.added DESC"
            )
    abstract override fun getPagedWatchedStreams(): PagingSource<Int, VodStream>
    
    @Query("""
    SELECT * FROM vodTable 
    INNER JOIN watchedVodStreamsTable 
    ON vodTable.streamId = watchedVodStreamsTable.streamId 
    ORDER BY watchedVodStreamsTable.added DESC 
    LIMIT :limit
""")
    abstract override fun getWatchedStreamsFlow(limit: Int?): Flow<List<VodStream>>

    @Query("SELECT *  FROM vodTable " +
            "INNER JOIN watchedVodStreamsTable ON vodTable.streamId = watchedVodStreamsTable.streamId "+
            " ORDER BY watchedVodStreamsTable.added DESC LIMIT :limit"
    )
    abstract suspend fun getWatchedStreams(limit: Int?): List<VodStream>

    //we use 'watched_' as prefix to avoid duplications error
    @Query("""SELECT 
watchedVodStreamsTable.streamId AS watched_streamId, 
watchedVodStreamsTable.added AS watched_added, 
watchedVodStreamsTable.progress AS watched_progress, 
watchedVodStreamsTable.totalProgress AS watched_totalProgress, 
watchedVodStreamsTable.backdrop AS watched_backdrop, 
        vodTable.*
         FROM vodTable
            INNER JOIN watchedVodStreamsTable 
            ON vodTable.streamId = watchedVodStreamsTable.streamId
            ORDER BY watchedVodStreamsTable.added DESC LIMIT :limit            
            """)
    abstract fun getWatchedStreamsAsIntermediateFlow(limit: Int?): Flow<List<WatchedIntermediateVodStream>>

    @Query("""SELECT 
watchedVodStreamsTable.streamId AS watched_streamId, 
watchedVodStreamsTable.added AS watched_added, 
watchedVodStreamsTable.progress AS watched_progress, 
watchedVodStreamsTable.totalProgress AS watched_totalProgress, 
watchedVodStreamsTable.backdrop AS watched_backdrop, 
        vodTable.*
         FROM vodTable
            INNER JOIN watchedVodStreamsTable 
            ON vodTable.streamId = watchedVodStreamsTable.streamId
            ORDER BY watchedVodStreamsTable.added DESC LIMIT :limit            
            """)
    abstract suspend fun getWatchedStreamsAsIntermediate(limit: Int?): List<WatchedIntermediateVodStream>

    @Query("SELECT EXISTS (SELECT 1 FROM vodTable WHERE streamId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM vodTable WHERE streamId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>
    @Query("SELECT COUNT(*) FROM vodTable ")
    abstract override suspend fun getSize(): Long?
    @Query("SELECT COUNT(*) FROM vodTable "
            +" WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
    )
    abstract override suspend fun getSize(categoryId: Int?): Long?
    @Query("SELECT COUNT(*) FROM vodTable"
            +" WHERE (:categoryId IS NULL OR categoryId = :categoryId)"
    )
    abstract override fun getSizeAsFlow(categoryId: Int?): Flow<Long?>
    @Query("DELETE FROM vodTable")
    abstract override suspend fun deleteAll()



    @Query("""
        SELECT * FROM vodTable
        ORDER BY rating DESC
        LIMIT :limit
        """)
    abstract fun topAsFlow(limit: Int): Flow< List<VodStream>>




    @RawQuery( )
    abstract suspend fun getVodByIcons( query: RoomRawQuery): List<VodStream>

    @Query("DELETE FROM TrendingMovies")
    abstract suspend fun deleteTrending()

    @Insert(onConflict =  OnConflictStrategy.REPLACE)
    abstract suspend fun insertTrending(newList: List<TrendingMovie>)

    @Query("""
SELECT 
    trending.streamIcon, 
    trending.name, 
    trending.adult, 
    trending.id, 
    trending.overview, 
    trending.backdrop,
    trending.popularity, 
    trending.releaseDate, 
    trending.voteAverage,
    vod.streamId
FROM TrendingMovies trending 
JOIN vodTable vod 
    ON vod.name LIKE trending.name
WHERE vod.streamIcon IS NOT NULL
GROUP BY vod.streamId
""")
    abstract fun trendingAsFlow(): Flow<List<TrendingMovie>>



}